import {useEffect} from "react";
import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import writtenNumber from "written-number";

import { CustomSwitch } from "../../../components/Switch/Switch";
import NextButton from "../../../components/NextButton/NextButton";
import RangeSlider from "../../../components/RangeSlider";
import PlaneIcon from "../../../assets/img/plane.svg";
import { whiteGrey, accentDefault } from "../../../constants/colors";
import { menuSettings } from "../../../constants/settings";
import { getCheckPaymentPs } from '../../../utils/productUtils';

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  flightSummary: {
    width: "100%",
    padding: "30px 40px",
    [down("sm")]: {
      background: whiteGrey,
      borderRadius: "10px",
      marginTop: "30px",
    },
  },
  summaryBox: {
    padding: "20px 0",
    borderBottom: "1px solid rgba(0, 0, 0, 0.3)",
  },
  customFontSize: {
    fontSize: "14px",
  },
  addTicketProtection: {
    transition: "all 0.3s ease",
    background: "rgb(74 148 236 / 10%)",
    borderRadius: "10px",
    color: accentDefault,
    fontSize: "10px",
    textTransform: "uppercase",
    padding: "10px 15px",
    fontFamily: "sbcBold",
    cursor: "pointer",
  },
  yourIp: {
    fontSize: "12px",
  }
}));

const FlightSummary = ({
  confirmTerms,
  handleNext,
  selectedFlight,
  tipsValue,
  acceptTipsValue,
  splitPaymentValue,
  manualSplitValue,
  cards,
  register,
  setValue,
  travelCare,
  airports,
  formState,
  user_ip,
  cardsAmmount,
  previewMode
}) => {
  const classes = useStyles();

  useEffect(() => {
    setValue("totalAmount", totalPriceCalc())
  }, [selectedFlight, tipsValue, acceptTipsValue, manualSplitValue, travelCare, selectedFlight?.travelCarePrice]);


  const calcAdditionalService = () => {
    let additionalPrice = 0;
    if (acceptTipsValue) {
      additionalPrice = additionalPrice + Number(tipsValue);
    }
    if (travelCare === "applyProtection") {
      additionalPrice = additionalPrice + selectedFlight?.travelCarePrice;
    }
    return additionalPrice?.toFixed(2);
  };

  const inhouseCharge = () => {
    const ckPs = getCheckPaymentPs( selectedFlight ) + 1
    const {tbc, airline} = selectedFlight.taxes

    return manualSplitValue ? tbc + airline * ckPs : tbc
  }

  const airlineCharge = () => {
    const {tbc, airline} = selectedFlight.taxes

    return manualSplitValue ? 0 : airline
  }

  const priceOfferCalc = () => {

    return inhouseCharge() + airlineCharge()
  }

  const totalPriceCalc = () => {
    let price = priceOfferCalc();
    if (travelCare === "applyProtection") {
      price = price + selectedFlight?.travelCarePrice;
    }
    if (acceptTipsValue) {
      price = price + Number(tipsValue);
    }
    return price.toFixed(2);
  };

  const numberToWrittenString = () => {
    const finalPrice = totalPriceCalc();
    const splittedPrice = finalPrice.split(".");
    return (
      <>{`(${writtenNumber(splittedPrice[0])} US dollars and ${writtenNumber(
        splittedPrice[1]
      )} cents)`}</>
    );
  };

  const yourIPString = () => {
    if(!user_ip)
      return ''

    return `Your IP: ${user_ip}`;
  };

  return (
    <Box className={classes.flightSummary}>
      <Grid container className={classes.summaryBox}>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="space-between"
            mb={2.5}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <Box display="flex" alignItems="flex-start">
              <Box mr={1.5}>
                <img src={PlaneIcon} alt="plane"/>
              </Box>
              <Typography variant="h3">Flight</Typography>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems={{ xs: "flex-start", sm: "flex-end" }}
            >
              {selectedFlight?.parts?.hasOwnProperty("depart") &&
                Object.keys(selectedFlight?.parts?.depart)?.length > 0 && (
                  <>
                    <Typography variant="body2">
                      {`${
                        airports[selectedFlight?.parts?.depart?.from]?.city
                      } (${selectedFlight?.parts?.depart?.from})- ${
                        airports[selectedFlight?.parts?.depart?.to]?.city
                      } (${selectedFlight?.parts?.depart?.to})`}
                    </Typography>
                    <Typography variant="body2">
                      {selectedFlight?.parts?.depart?.date}
                    </Typography>
                  </>
                )}
              {selectedFlight?.parts?.hasOwnProperty("return") &&
                Object.keys(selectedFlight?.parts?.return)?.length > 0 && (
                  <>
                    <Box>
                      {`${
                        airports[selectedFlight?.parts?.return?.from]?.city
                      } (${selectedFlight?.parts?.return?.from})- ${
                        airports[selectedFlight?.parts?.return?.to]?.city
                      } (${selectedFlight?.parts?.return?.to})`}
                    </Box>
                    <Box>{selectedFlight?.parts?.return?.date}</Box>
                  </>
                )}
              {selectedFlight?.parts?.multiple?.map((part, index) => (
                <>
                  {index !== selectedFlight?.parts?.multiple?.length - 1 ? (
                    <>
                      <Typography variant="body2">
                        {`${airports[part.from]?.city} (${part.from})
                      -
                      ${airports[part.to]?.city} (${part.to})`}
                      </Typography>
                      <Typography variant="body2">{part.date}</Typography>
                    </>
                  ) : (
                    <>
                      <Box>
                        {`${airports[part.from]?.city} (${part.from})
                      -
                      ${airports[part.to]?.city} (${part.to})`}
                      </Box>
                      <Box>
                        <Typography variant="body2">{part.date}</Typography>
                      </Box>
                    </>
                  )}
                </>
              ))}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="space-between" mb={2}>
            <Box>
              <Typography variant="h4">
                {selectedFlight?.parts?.hasOwnProperty("multiple")
                  ? "Multi City"
                  : (selectedFlight?.parts?.return && Object.keys(selectedFlight?.parts?.return).length > 0)
                  ? "Round Flight"
                  : "One-Way Flight"}
              </Typography>
            </Box>
            <Box>
              <Typography variant="h4">{`$ ${priceOfferCalc().toFixed( 2 )}`}</Typography>
            </Box>
          </Box>
        </Grid>
        <Grid container item xs={12} justify="flex-end">
          <Grid item xs={12} sm={8}>
            {!!selectedFlight?.taxes.airline && (
              (getCheckPaymentPs( selectedFlight ) > 0 && !manualSplitValue) || getCheckPaymentPs( selectedFlight ) === 0
            ) && (
              <Box display="flex" justifyContent="space-between" mb={1.5}>
                <Box>
                  <Typography variant="caption">
                    To be processed by airline
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption">
                    <b>{`$ ${selectedFlight?.taxes?.airline.toFixed(2)}`}</b>
                  </Typography>
                </Box>
              </Box>
            )}
            {!!selectedFlight?.taxes.tbc && (
              <Box display="flex" justifyContent="space-between" mb={1.5}>
                <Box>
                  <Typography variant="caption">
                    To be processed by {process.env?.REACT_APP_PROJECT?.toUpperCase()}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption">
                    <b>{`$ ${
                      (getCheckPaymentPs( selectedFlight ) > 0 && manualSplitValue) ?
                        priceOfferCalc().toFixed( 2 ) :
                        selectedFlight?.taxes?.tbc.toFixed( 2 )
                    }`}</b>
                  </Typography>
                </Box>
              </Box>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid container className={classes.summaryBox}>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="space-between" mb={2}>
            <Box>
              <Typography variant="h4">Additional Service</Typography>
            </Box>
            <Box>
              <Typography variant="h4">
                {`$ ${calcAdditionalService()}`}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid container item xs={12} justify="flex-end">
          <Grid item xs={12} sm={8}>
            <Box
              display="flex"
              justifyContent="space-between"
              mb={1.5}
              alignItems="center"
            >
              <Box>
                <Typography variant="caption">Ticket Protection</Typography>
              </Box>
              <Box>
                {travelCare !== "applyProtection" ? (
                  <Box
                    onClick={() => setValue("travelCare", "applyProtection")}
                    className={classes.addTicketProtection}
                  >
                    + Add ticket protection
                  </Box>
                ) : (
                  <Box>
                    <Typography variant="caption">
                      <b>{`$ ${selectedFlight?.travelCarePrice}`}</b>
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
            <Box display="flex" justifyContent="space-between" mb={1.5}>
              <Box>
                <Typography variant="caption">
                  Tips for excellent service
                </Typography>
              </Box>
              <Box>
                <Typography variant="caption">
                  <b>{`$ ${
                    (acceptTipsValue && Number(tipsValue).toFixed(2)) || "0.00"
                  }`}</b>
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="space-between" mt={2} mb={2}>
            <Box display="flex" alignItems="center">
              <Typography variant="h2">Total:</Typography>
            </Box>
            <Box display="flex" flexDirection="column" alignItems="flex-end">
              <Typography variant="h1" className="green">
                {`$ ${totalPriceCalc()}`}
              </Typography>
              <Typography
                variant="caption"
                align="right"
                style={{ maxWidth: "300px" }}
              >
                {numberToWrittenString()}
              </Typography>
            </Box>
          </Box>
          <Box mt={2} mb={3}>
            <CustomSwitch
              name="confirmTerms"
              value={confirmTerms}
              label={
                <Box>
                  <Box mb={1}>
                    <Typography variant="h4">
                      By activating this button:
                    </Typography>
                  </Box>
                  <Typography className={classes.customFontSize}>
                    1. I agree that my credit card will be charged the above
                    total amount (your card may be billed in multiple charges
                    totaling the final price). 2. I confirm that the flight
                    itinerary is correct and the spelling of the name(s) of the
                    passenger(s) are matching the valid travel documents. 3. I
                    accept the{" "}
                    <a
                      href={menuSettings.link.terms}
                      className="blue"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Terms and Conditions
                    </a>{" "}
                    and{" "}
                    <a
                      href={menuSettings.link.privacy}
                      className="blue"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Privacy Policy
                    </a>
                    .
                  </Typography>
                </Box>
              }
            />
          </Box>
          {splitPaymentValue && (
            <Box mt={1} mb={2}>
              <RangeSlider
                max={totalPriceCalc()}
                cards={cards}
                register={register}
                setValue={setValue}
                initialAmmounts={cardsAmmount}
                manualSplitValue={manualSplitValue}
                selectedFlight={selectedFlight}
                tipsValue={tipsValue}
                acceptTipsValue={acceptTipsValue}
                travelCareValue={travelCare}
                isForceManualSplitValue={false}
                previewMode={previewMode}
              />
            </Box>
          )}
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography
              variant="caption"
              className={classes.yourIp}
            >
              {yourIPString()}
            </Typography>
            <NextButton
              selectedFlight={selectedFlight}
              handleNext={handleNext}
              location="form"
              disabled={
                !confirmTerms || Object.keys(formState.errors).length > 0
              }
              hidePrice={true}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FlightSummary;
